import { Card, Flex, Text } from "@chakra-ui/react";
import { DefaultPriceData, PricesData } from "../../schema/price-board.schema";
import { AppColors } from "@/styles/colors";
import { defaultBoardHeaderElements } from "../../schema/header-elements";
import dayjs from "dayjs";
import { formatCurrency } from "@/utils/format-currency";
import { StandardTable } from "@/components/table/StandardTable";

interface Props {
  sectionData?: PricesData;
}

export const UnionPricesCard = ({ sectionData }: Props) => {
  return (
    <Card.Root
      maxW="full"
      marginTop="30px"
      borderRadius="8px"
      data-testid="union-prices-card"
    >
      <Card.Body
        paddingX="10px"
        paddingY="12px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Flex flexDir="column" gap="18px">
          <Text className="amd-card-title" fontSize="20px">
            Precio Unión
          </Text>
          <StandardTable
            headers={defaultBoardHeaderElements}
            items={
              sectionData?.preciosUnion.map((el: DefaultPriceData) => ({
                ...el,
                fecha: dayjs(el?.fecha).format("DD/MM/YYYY"),
                precioSoja: `$${formatCurrency(el?.precioSoja, false)}`,
                precioMaiz: `$${formatCurrency(el?.precioMaiz, false)}`,
                precioTrigo: `$${formatCurrency(el?.precioTrigo, false)}`,
              })) ?? []
            }
            selection={[]}
            setSelection={() => null}
            noSelection
            noActions
            noBorder
          />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
